import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	allSchemes: [],
};

const allSchemesSlice = createSlice({
	name: 'allSchemes',
	initialState: initialState,
	reducers: {
		setAllSchemes: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setAllSchemes, reset } = allSchemesSlice.actions;

export default allSchemesSlice.reducer;